export interface PhysicsStateSample {
  positionX: number;
  positionY: number;
  velocityX: number;
  velocityY: number;
  boundsMinX: number;
  boundsMaxX: number;
  boundsMinY: number;
  boundsMaxY: number;
}

export function hasFinitePhysicsState(sample: PhysicsStateSample): boolean {
  return Object.values(sample).every(Number.isFinite);
}
